import { gql } from '@apollo/client';

const UPDATE_USER_DISPLAY_PHONE_NUMBER = gql`
  mutation UpdateUserDisplayPhoneNumber($params: UpdateUserDisplayPhoneNumberParams!) {
    updateUserDisplayPhoneNumber(params: $params)
  }
`;

export default UPDATE_USER_DISPLAY_PHONE_NUMBER;
